import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSdCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSdCard"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22H20V10.7877L18 7.53772V2H4ZM10 6V10H8.5V6H10ZM13.5 6H12V10H13.5V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSdCard;
